import { Configuration, PublicClientApplication } from '@azure/msal-browser';

// Get configuration from environment variables
const clientId = import.meta.env.VITE_AZURE_CLIENT_ID;
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID;
const redirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI;

// MSAL configuration for v5
export const msalConfig: Configuration = {
  auth: {
    clientId: clientId || '',
    authority: `https://login.microsoftonline.com/${tenantId || 'common'}`,
    redirectUri: redirectUri || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          console.log(`[MSAL ${level}]`, message);
        }
      },
      piiLoggingEnabled: false,
      logLevel: 2,
    },
  },
};

// Create the main instance of MSAL Public Client Application
export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL on app startup and process any pending redirect response.
// Passing { navigateToLoginRequestUrl: false } prevents MSAL from navigating
// back to the originating URL after login, which can carry stale hash
// fragments that cause the token response to be misread as invalid.
msalInstance
  .initialize()
  .then(() => msalInstance.handleRedirectPromise({ navigateToLoginRequestUrl: false }))
  .catch((error) => {
    console.error('MSAL initialization error:', error);
  });

// Login request
export const loginRequest = {
  scopes: ['User.Read'],
};

export default msalConfig;
